// Module
var code = "<div ng-class=\"verticalCenter === true ? 'grid-count' : 'grid-count no-vertical-center'\"> <span translate=\"{{message}}\" translate-values=\"{ count: count }\" translate-interpolation=\"messageformat\"></span> </div> ";
// Exports
var _module_exports =code;;
var path = '/views/common/grid_count.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;